import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { SagaIterator } from 'redux-saga';

// Global Selectors
// @ts-ignore
import { idTokenSelector } from 'services/auth/selectors';

// Global Services
import {
    setSubmitHasFailed,
    deleteItems
} from 'services/virtualizedTable/actions';
import { updateQueryString } from 'services/router/actions';

import { ERROR_MODAL_QUERY_STRING_PARAM } from 'components/ErrorModal/constants';

// Local Types
import {
    RequestCreateVarietyAction,
    RequestVarietyUpdateAction
} from './types';

// Local Constants
import {
    VARIETY_CREATE_REQUESTED,
    VARIETY_CREATE_NAMESPACE,
    VARIETY_UPDATE_NAMESPACE,
    VARIETY_UPDATE_REQUESTED
} from './constants';

// Local Actions
import {
    succeededCreateVariety,
    failedCreateVariety,
    setVarieties,
    succeededUpdateVariety,
    failedUpdateVariety
} from './actions';

// Environment
const { REACT_APP_API_URL } = process.env;

export function* createVariety(
    action: RequestCreateVarietyAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);
    const url = `${REACT_APP_API_URL}/v1/Varieties`;

    try {
        const response = yield call(axios, url, {
            method: 'post',
            headers: {
                Authorization: idToken
            },
            data: action.payload
        });
        const { data: variety } = response;

        yield all([
            put(succeededCreateVariety(response)),
            put(
                setVarieties({
                    [variety.id]: variety
                })
            )
        ]);
    } catch (error) {
        yield all([
            put(failedCreateVariety(error)),
            put(setSubmitHasFailed(true)),
            put(deleteItems([action.payload.uuid])),
            put(
                updateQueryString({
                    [ERROR_MODAL_QUERY_STRING_PARAM]: VARIETY_CREATE_NAMESPACE
                })
            )
        ]);
    }
}

export function* watchVarietyCreateRequested(): SagaIterator {
    yield takeLatest(VARIETY_CREATE_REQUESTED, createVariety);
}

export function* updateVariety(
    action: RequestVarietyUpdateAction
): SagaIterator {
    const idToken = yield select(idTokenSelector);
    const { id, ...payload } = action.payload;

    try {
        const url = `${REACT_APP_API_URL}/v1/Varieties/${id}`;
        const response = yield call(axios, url, {
            method: 'patch',
            headers: {
                Authorization: idToken
            },
            data: payload
        });
        const { data: variety } = response;

        yield all([
            put(succeededUpdateVariety(response)),
            put(
                setVarieties({
                    [variety.id]: variety
                })
            )
        ]);
    } catch (error) {
        yield all([
            put(failedUpdateVariety(error)),
            put(setSubmitHasFailed(true)),
            put(
                updateQueryString({
                    [ERROR_MODAL_QUERY_STRING_PARAM]: VARIETY_UPDATE_NAMESPACE
                })
            )
        ]);
    }
}

export function* watchVarietyUpdateRequested(): SagaIterator {
    yield takeLatest(VARIETY_UPDATE_REQUESTED, updateVariety);
}

export default function* varietiesSagas(): SagaIterator {
    yield all([
        fork(watchVarietyCreateRequested),
        fork(watchVarietyUpdateRequested)
    ]);
}
